// Get the current breakpoint
function getBreakpoints() {
  return JSON.parse(
    JSON.parse(
      window
        .getComputedStyle(document.body, '::before')
        .content.replaceAll('\\a', '')
    )
  );
}

// Get the current breakpoint
function respondToBreakpoint(name) {
  var breakpoints = getBreakpoints();
  if (breakpoints) {
    return window.matchMedia(breakpoints[name]).matches;
  }
  return false;
}

function initShopTheLook() {
  $(".ShopTheLook__Dot").on("click", function(){
    setTimeout(() => {
      $("html").removeClass("no-scroll");
      $(".ShopTheLook").removeClass("is-zoomed");
    }, 100);
  });
}

$(document).ready(function () {
  initLanguageSelector();
  initDrawer();
  initShopTheLook();
  onElementInserted('body', ".hs-input[type='email']", initNewsletter);
  initMegamenu();
});

function initLanguageSelector(){
  var languagesList = window.LANGUAGES_LIST.split(",");
  for (var language of languagesList ){
    var $element = $('[name="locale_code"][value="' + language + '"]');
    if( $element.length > 0 ){
      $element.hide();
    }
  }
}

function initMegamenu(){
  $(document).on("scroll", function(){
    $(".HorizontalList__Item .MegaMenu").attr("aria-hidden", "true");
  })
}

function initDrawer() {
  document.querySelectorAll('#menu-level-link').forEach((el) => {
    el.addEventListener('click', function (event) {
      var link = el.getAttribute('href');
      event.preventDefault();
      event.stopPropagation();
      location.href = link;
    });
  });

  $('.Collapsible__Button--first-level').on('click', function (e) {
    var sectionTitle = $(e.target).data('title');
    $('.Drawer__Header--second-level-menu').html(sectionTitle);
    $('.Drawer__Header--second-level-menu').show();
    $('.Drawer__Close--close').hide();
    $('.Drawer__Close--back').show();
  });

  $('.Drawer__Close--back').on('click', function () {
    $(".Collapsible__Button--first-level[aria-expanded='true']")
      .parent('.Collapsible')
      .find(".Text--subdued[aria-expanded='true']")
      .click();
    $(".Collapsible__Button--first-level[aria-expanded='true']").click();
    $('.Drawer__Close--back').hide();
    $('.Drawer__Close--close').show();
    $('.Drawer__Header--second-level-menu').hide();
  });
}

function initNewsletter() {
  $(".hs-input[type='email']").attr('placeholder', 'Enter your email address');
  $(".hs-input[name='firstname']").attr(
    'placeholder',
    $("[id^='label-firstname'] span").html()
  );
  $(".hs-input[name='lastname']").attr(
    'placeholder',
    $("[id^='label-lastname'] span").html()
  );
  $(".hs-input[name='numero_ordine']").attr(
    'placeholder',
    $("[id^='label-numero_ordine'] span").html()
  );
  $('.hs-submit .actions').on('click', function () {
    $('.hs-button').click();
  });
}

function onElementInserted(containerSelector, elementSelector, callback) {
  var onMutationsObserved = function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        var elements = $(mutation.addedNodes).find(elementSelector);
        for (var i = 0, len = elements.length; i < len; i++) {
          callback(elements[i]);
        }
      }
    });
  };
  var MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver;
  var observer = new MutationObserver(onMutationsObserved);
  observer.observe($(containerSelector)[0], { childList: true, subtree: true });
}

$(document).ready(function () {
  if ($('.Carousel__Cell').length > 0) {
    $('.Carousel__Cell').css('height', '100%');
  }
});
